import React from 'react';
import ReactDOM from 'react-dom';
import {checkToken, checkVVauthorization, getOrderState, fetchInstantBookingActualStateByHash} from 'api';
import {Router, Route, IndexRoute, Redirect} from 'react-router';
import ga from 'react-ga';
import * as queryString from 'query-string';
import config from '../configs/client';
import Application from './components/Application';
import CategoryScreen from 'components/CategoryScreen';
import CategoryMovingScreen from 'components/Categories/Moving';
import CargosScreen from 'components/CargosScreen';
import MovingCargosScreen from 'components/MovingCargosScreen';
import ParametersScreen from 'components/ParametersScreen';
import RouteScreen from 'components/RouteScreen';
import ContactsScreen from 'components/ContactsScreen';
import SocialAuthScreen from 'components/SocialAuthScreen';
import InstantBookingScreen from 'components/InstantBookingScreen';
import SuccessScreen from './components/SuccessScreen';
import InstantBookingFinalInfo from './components/InstantBookingFinalInfo';
import InstantBookingContactsScreen from './components/InstantBookingContactsScreen';
import Spinner from 'components/Spinner';
import Forbidden from 'components/Forbidden';
import ActionCreators from 'actions/ActionCreators';
import CargosStore from 'stores/CargosStore';
import GeneralStore from 'stores/GeneralStore';
import UserStore from 'stores/UserStore';
import InstantBookingStore from 'stores/InstantBookingStore';
import history from 'core/history';
import {owox} from 'core/utils';
import GeoConstants from 'constants/Geo';
import ReactPixel from 'react-facebook-pixel';

function trackPath() {
    const uri = '/booking' + this.state.location.pathname + this.state.location.search;

    if (typeof window.ga === 'function') {
        if (process.env.NODE_ENV === 'production') {
            window.ga('set', 'hostname', 'www.vezetvsem.ru');
        }
        window.ga('set', 'page', uri);
    }

    ga.pageview(uri);

    if (window.ym) {
        window.ym('1315865', 'hit', `${window.location.protocol}//${window.location.host}${uri}`);
    }

    if (typeof window.fbq === 'function') {
        ReactPixel.track('ViewContent', {
            value: uri,
        });
    }
}

function onMovingEnter(route) {

    var categoryName = '';

    switch (route.params.partner) {
        case 'cian':
            categoryName = 'moving_cian';
            break;
        default:
            categoryName = 'moving';
            break;
    }

    ActionCreators.selectCategory(categoryName);
}

function onUpdateRoute() {
    // Check if user is authorized on Vezetvsem main site.
    if (!UserStore.wasAuthChecked()) {
        checkVVauthorization().then(
            result => {
                if (result && result.authorized) {
                    ActionCreators.setVVauthorizationStatus(result.authorized)
                    ActionCreators.setAutologinHash(result.autologin_hash)
                    ActionCreators.updateUser({
                        id: result.user_id,
                        email: result.email,
                    })
                    ActionCreators.showInstantBookingGoToAuctionButton()
                    ActionCreators.completeInstantBookingEmail()

                    if (result.menu.balance.amount) {
                        ActionCreators.setUserBalance(result.menu.balance.amount)
                    }

                    if (result.user_id) {
                        window.ga('set', 'userId', result.user_id);
                        window.ga('set', 'dimension9', result.user_id);
                        window.ga('set', 'dimension1', 'merchants');
                    }
                } else {
                    ActionCreators.setVVauthorizationStatus({authorized: false})
                    // ActionCreators.hideInstantBookingGoToAuctionButton()
                }

                // Wait for possible GA set userId
                trackPath.apply(this);
            },
        ).catch(error => {
            trackPath.apply(this);
        });
    } else {
        trackPath.apply(this);
    }

    document.body.scrollTop = 0 // For Safari
    document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
}

function _checkUnallowedEntry(nextState, replace) {
    const cargos = CargosStore.getDeliveryCargos()

    if (cargos.size === 0) {
        replace('/')
    }
}

function _checkSelectedInstantPrice(nextState, replace) {
    const partDay = InstantBookingStore.getPartDay()
    const dayPrice = partDay.valueSeq().get(0)

    if (!dayPrice) {
        replace(`/category/${nextState.params.categoryId}/instant${nextState.location && nextState.location.search ? nextState.location.search : ''}`)
        alert('Сначала выберите дату!')
    }
}

if (process.env.NODE_ENV !== 'production') {
    global.Perf = require('react-addons-perf');
}

// Проверка валидности токена.
// Токен работает как одноразовый пароль.
const token = queryString.parse(window.location.search).token;
if (token) {
    checkToken(token).then(
        done => ActionCreators.setValidToken(token),
    ).catch();
}

ga.initialize(config.ga.tracking, {capitalize: false});
if (process.env.NODE_ENV === 'production') {
    ga.plugin.require('OWOXBIStreaming', {sessionIdDimension: 19});
    owox();
}

async function setMode() {
    const query = queryString.parse(window.location.search);
    const orderId = query.oid ? parseInt(query.oid, 10) : 0;
    const invoiceId = query.iid ? parseInt(query.iid, 10) : 0;
    const carrierId = query.carrier_id ? parseInt(query.carrier_id, 10) : 0;
    const fromPerevezi = query.from_perevezi ? parseInt(query.from_perevezi, 10) : 0;
    const isB2B = query.b2b ? parseInt(query.b2b, 10) : 0;
    const isWidget = query.widget ? parseInt(query.widget, 10) : 0;
    const clickId = query.clickId ? query.clickId : 0;
    const isBetaInstantBooking = query.beta_instant_booking ? parseInt(query.beta_instant_booking, 10) : 0;
    const priceHash = query.price_hash ? query.price_hash : '';
    const priceHashLog = query.phl ? query.phl : '';
    const host = window.location.host;

    if (orderId > 0) {
        return await setEditMode(orderId, invoiceId);
    }

    if (isB2B) {
        ActionCreators.setB2B();
    }

    if (isBetaInstantBooking) {
        ActionCreators.showInstantBookingByQueryParam()
    } else {
        ActionCreators.hideInstantBookingByQueryParam()
    }

    if (carrierId > 0) {
        ActionCreators.setCarrierId(carrierId);
        return true;
    }

    if (fromPerevezi === 1) {
        ActionCreators.setPereveziModeOn();
    }

    if (isWidget > 0) {
        ActionCreators.setWidgetModeOn();
    }

    if (clickId) {
        ActionCreators.setClickId(clickId);
    }

    if (config.israel_hosts.includes(host)) {
        ActionCreators.setIsraelModeOn();
        ActionCreators.setDefaultCountry(GeoConstants.COUNTRY_ISRAEL);

        ReactPixel.init(config.facebook_pixel.id, {}, {
            autoConfig: true,
            debug: process.env.NODE_ENV !== 'production',
        });
    }

    if (priceHash) {
        return await fetchInstantBookingActualState(priceHash)
    }

    if (priceHashLog) {
        return await fetchInstantBookingActualState(priceHashLog, true)
    }
}

async function setEditMode(orderId, invoiceId = 0) {
    return await getOrderState(orderId, invoiceId)
    .then((normalizedState) => {
        if (typeof normalizedState === 'object' &&
            Object.keys(normalizedState).length > 0 &&
            normalizedState.user &&
            normalizedState.user.autologin_hash) {

            ActionCreators.setOrderId(orderId);
            ActionCreators.setMode('edit');
            ActionCreators.denormalizeState(normalizedState);

            return true;
        } else {
            return false;
        }
    });
}

async function fetchInstantBookingActualState(priceHash, showFullLog = false) {
    const data = await fetchInstantBookingActualStateByHash(priceHash, showFullLog)

    if (data && data.response && data.response.state) {
        ActionCreators.denormalizeState(data.response.state);
        ActionCreators.blockInstantBookingSpinner()
        ActionCreators.completeInstantBookingEmail()

        if (showFullLog) {
            ActionCreators.instantBookingHashLogModeOn()

            ActionCreators.setInstantBookingPrices(data.response.prices.price_pred)
            ActionCreators.setInstantBookingServices(data.response.prices.price_services)

            // Debug info
            if (data.response.prices.order) {
                ActionCreators.setInstantBookingDebugData(data.response.prices.order)
            }
        }

        return true
    }

    return false
}

window.__getNormalizedState = GeneralStore.getNormalizedState;

(async function() {

    ReactDOM.render(<Spinner/>, document.getElementById('application'));

    // If edit mode, we wait for data
    let success = await setMode();
    if (success === false) {
        ReactDOM.render(<Forbidden/>, document.getElementById('application'));
        return;
    }

    ReactDOM.render(
        (
            <Router history={history}
                    onUpdate={onUpdateRoute}>
                <Route component={Application} path='/'>
                    {GeneralStore.isAddMode() ?
                        <IndexRoute component={CategoryScreen}/>
                        : ''}
                    <Route path='/category/moving(_:partner)'
                           component={CategoryMovingScreen}
                           onEnter={onMovingEnter}/>
                    <Route path='/category/moving(_:partner)/cargos'
                           component={MovingCargosScreen}
                           onEnter={onMovingEnter}/>
                    <Route path='/category/moving(_:partner)/params'
                           component={ParametersScreen}
                           onEnter={onMovingEnter}/>
                    <Route path='/category/:categoryId'
                           component={CargosScreen}
                           onEnter={(nextState) => {
                               ActionCreators.selectCategory(nextState.params.categoryId);
                           }}/>
                    <Route path='/category/:categoryId/params'
                           component={ParametersScreen}
                           onEnter={(nextState) => {
                               ActionCreators.selectCategory(nextState.params.categoryId);
                           }}/>
                    <Route path='/category/:categoryId/route'
                           component={RouteScreen}
                           onEnter={(nextState, replace) => {
                               _checkUnallowedEntry(nextState, replace);
                               ActionCreators.selectCategory(nextState.params.categoryId);
                           }}/>
                    <Route path='/category/:categoryId/instant'
                           component={InstantBookingScreen}
                           onEnter={(nextState, replace) => {
                               _checkUnallowedEntry(nextState, replace);
                               ActionCreators.selectCategory(nextState.params.categoryId);
                           }}/>
                    <Route path='/category/:categoryId/contacts'
                           component={ContactsScreen}
                           onEnter={(nextState, replace) => {
                               _checkUnallowedEntry(nextState, replace);
                               ActionCreators.selectCategory(nextState.params.categoryId);
                           }}/>
                    <Route
                        path="/category/:categoryId/instant-final-info"
                        component={InstantBookingFinalInfo}
                        onEnter={(nextState, replace) => {
                            _checkUnallowedEntry(nextState, replace)
                            _checkSelectedInstantPrice(nextState, replace)
                            ActionCreators.selectCategory(nextState.params.categoryId)
                        }}/>
                    <Route
                        path="/category/:categoryId/instant-contacts"
                        component={InstantBookingContactsScreen}
                        onEnter={(nextState, replace) => {
                            _checkUnallowedEntry(nextState, replace);
                            ActionCreators.selectCategory(nextState.params.categoryId);
                        }}/>
                    <Route path='/social_auth/(:type)'
                           component={SocialAuthScreen}
                           onEnter={() => {
                               ActionCreators.showLoadingOverlay();
                           }}/>
                    <Route path='/success' component={SuccessScreen}/>
                    <Redirect from="*" to="/"/>
                </Route>
            </Router>
        ),
        document.getElementById('application'),
    );
})();



// WEBPACK FOOTER //
// ./client/index.js